// 2023 Topps Star Wars Chrome Black — GENERATED by pipeline-publish (2026-05-25)
// =============================================================================
// Auto-generated from the set draft. Colors, sub-set types, ordering, and the
// SET_REGISTRY entry below are filled in. REVIEW before committing:
//   - Any placeholder color marker (a parallel name not in the standard color
//     map; the commit guard blocks until every one is resolved).
//   - Rule-7 base serial slots on numbered auto/sketch sub-sets (see in-array
//     notes; the warnings list above flags only sub-sets actually missing one).
//   - Sanity-check the auto-classified sub-set `type` and ordering.
//   - Any placeholder in the SET_REGISTRY entry below (only present if no DB
//     sets row exists for this slug, or fields are blank).
//   - A source/specimen pass on parallel names + print runs.
//   - node --check src/sets/2023-chrome-black.js if committing by hand, then commit + push.
//
// SET_REGISTRY entry (paste into src/setRegistry.js):
//   {
//     id: "2023-chrome-black",
//     name: "2023 Topps Star Wars Chrome Black",
//     shortName: "Chrome Black 2023",
//     year: 2023,
//     brand: "Topps",
//     category: 'Star Wars',
//     releaseDate: "2023",
//     totalCards: 267,
//     description: "Topps 2023 Topps Star Wars Chrome Black trading card set.",
//     color: "#4fc3f7",
//     accentColor: "#f0c040",
//     dataFile: "2023-chrome-black",
//   },
// =============================================================================

export const SETS = [
  {
    id: "base-cards",
    type: "base",
    title: "BASE CARDS",
    parallels: [
        { id: "refractors", name: "Refractors", print_run: 199, color: "#c8d8f0" },
        { id: "purple-refractors", name: "Purple Refractors", print_run: 125, color: "#b060ff" },
        { id: "green-refractors", name: "Green Refractors", print_run: 99, color: "#00e676" },
        { id: "blue-refractors", name: "Blue Refractors", print_run: 75, color: "#2979ff" },
        { id: "gold-refractors", name: "Gold Refractors", print_run: 50, color: "#f0c040" },
        { id: "orange-refractors", name: "Orange Refractors", print_run: 25, color: "#ff9100" },
        { id: "magenta-refractors", name: "Magenta Refractors", print_run: 10, color: "#9aa7c0" },
        { id: "red-refractors", name: "Red Refractors", print_run: 5, color: "#ff1744" },
        { id: "superfractors", name: "Superfractors", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "1", name: "Obi-Wan Kenobi (Star Wars: Return of the Jedi)" },
        { n: "2", name: "Jar Jar Binks (Star Wars: Attack of the Clones)" },
        { n: "3", name: "Maz Kanata (Star Wars: The Force Awakens)" },
        { n: "4", name: "Baze Malbus (Rogue One: A Star Wars Story)" },
        { n: "5", name: "BB-8 (Star Wars: The Rise of Skywalker)" },
        { n: "6", name: "Bossk (Star Wars: The Empire Strikes Back)" },
        { n: "7", name: "Gor Koresh (The Mandalorian)" },
        { n: "8", name: "Lando Calrissian (Star Wars: The Empire Strikes Back)" },
        { n: "9", name: "Dexter Jettster (Star Wars: Attack of the Clones)" },
        { n: "10", name: "Rey (Star Wars: The Last Jedi)" },
        { n: "11", name: "Beru Lars (Star Wars: A New Hope)" },
        { n: "12", name: "Q9-0 (The Mandalorian)" },
        { n: "13", name: "Bix Caleen (Andor)" },
        { n: "14", name: "Admiral Piett (Star Wars: Return of the Jedi)" },
        { n: "15", name: "Admiral Ackbar (Star Wars: The Last Jedi)" },
        { n: "16", name: "Bib Fortuna (Star Wars: Return of the Jedi)" },
        { n: "17", name: "Qui-Gon Jinn (Star Wars: The Phantom Menace)" },
        { n: "18", name: "Major Bren Derlin (Star Wars: The Empire Strikes Back)" },
        { n: "19", name: "L3-37 (Solo: A Star Wars Story)" },
        { n: "20", name: "Kylo Ren (Star Wars: The Last Jedi)" },
        { n: "21", name: "Garven Dreis (Star Wars: A New Hope)" },
        { n: "22", name: "Moff Gideon (The Mandalorian)" },
        { n: "23", name: "Wedge Antilles (Star Wars: The Empire Strikes Back)" },
        { n: "24", name: "EV-9D9 (Star Wars: Return of the Jedi)" },
        { n: "25", name: "Darth Vader (Star Wars: Return of the Jedi)" },
        { n: "26", name: "Figrin D'an (Star Wars: A New Hope)" },
        { n: "27", name: "General Veers (Star Wars: The Empire Strikes Back)" },
        { n: "28", name: "Shmi Skywalker (Star Wars: The Phantom Menace)" },
        { n: "29", name: "Maul (Solo: A Star Wars Story)" },
        { n: "30", name: "Owen Lars (Star Wars: A New Hope)" },
        { n: "31", name: "The Grand Inquisitor (Obi-Wan Kenobi)" },
        { n: "32", name: "Migs Mayfeld (The Mandalorian)" },
        { n: "33", name: "Watto (Star Wars: The Phantom Menace)" },
        { n: "34", name: "Mace Windu (Star Wars: Attack of the Clones)" },
        { n: "35", name: "Captain Phasma (Star Wars: The Force Awakens)" },
        { n: "36", name: "Zam Wesell (Star Wars: Attack of the Clones)" },
        { n: "37", name: "Doctor Cornelius Evazan (Star Wars: A New Hope)" },
        { n: "38", name: "Wuher (Star Wars: A New Hope)" },
        { n: "39", name: "Grogu (The Book of Boba Fett)" },
        { n: "40", name: "Finn (Star Wars: The Last Jedi)" },
        { n: "41", name: "Zett Jukassa (Star Wars: Revenge of the Sith)" },
        { n: "42", name: "Zorii Bliss (Star Wars: The Rise of Skywalker)" },
        { n: "43", name: "Logray (Star Wars: Return of the Jedi)" },
        { n: "44", name: "Padmé Amidala (Star Wars: Attack of the Clones)" },
        { n: "45", name: "Rancor (The Book of Boba Fett)" },
        { n: "46", name: "General Grievous (Star Wars: Revenge of the Sith)" },
        { n: "47", name: "Aayla Secura (Star Wars: Revenge of the Sith)" },
        { n: "48", name: "Nute Gunray (Star Wars: Revenge of the Sith)" },
        { n: "49", name: "Luke Skywalker (Star Wars: The Empire Strikes Back)" },
        { n: "50", name: "Beaumont Kin (Star Wars: The Rise of Skywalker)" },
        { n: "51", name: "Kit Fisto (Star Wars: Attack of the Clones)" },
        { n: "52", name: "Dak Ralter (Star Wars: The Empire Strikes Back)" },
        { n: "53", name: "Boss Nass (Star Wars: The Phantom Menace)" },
        { n: "54", name: "Jabba The Hutt (Star Wars: A New Hope)" },
        { n: "55", name: "Sy Snootles (Star Wars: Return of the Jedi)" },
        { n: "56", name: "General Rieekan (Star Wars: The Empire Strikes Back)" },
        { n: "57", name: "Dormé (Star Wars: Attack of the Clones)" },
        { n: "58", name: "Tion Medon (Star Wars: Revenge of the Sith)" },
        { n: "59", name: "R2-D2 (Star Wars: Revenge of the Sith)" },
        { n: "60", name: "Jannah (Star Wars: The Rise of Skywalker)" },
        { n: "61", name: "K-2SO (Rogue One: A Star Wars Story)" },
        { n: "62", name: "Momaw Nadon (Star Wars: A New Hope)" },
        { n: "63", name: "Bo-Katan Kryze (The Mandalorian)" },
        { n: "64", name: "Princess Leia (Star Wars: Return of the Jedi)" },
        { n: "65", name: "Zuckuss (Star Wars: The Empire Strikes Back)" },
        { n: "66", name: "Eeth Koth (Star Wars: Attack of the Clones)" },
        { n: "67", name: "Tobias Beckett (Solo: A Star Wars Story)" },
        { n: "68", name: "Yaddle (Star Wars: The Phantom Menace)" },
        { n: "69", name: "Han Solo (Star Wars: The Empire Strikes Back)" },
        { n: "70", name: "Jan Dodonna (Star Wars: A New Hope)" },
        { n: "71", name: "Kaydel Connix (Star Wars: The Last Jedi)" },
        { n: "72", name: "Mon Mothma (Star Wars: Revenge of the Sith)" },
        { n: "73", name: "Luminara Unduli (Star Wars: Attack of the Clones)" },
        { n: "74", name: "Anakin Skywalker (Star Wars: The Phantom Menace)" },
        { n: "75", name: "Bodhi Rook (Rogue One: A Star Wars Story)" },
        { n: "76", name: "Dryden Vos (Solo: A Star Wars Story)" },
        { n: "77", name: "Cassian Andor (Andor)" },
        { n: "78", name: "Paige Tico (Star Wars: The Last Jedi)" },
        { n: "79", name: "The Mandalorian (The Book of Boba Fett)" },
        { n: "80", name: "Babu Frik (Star Wars: The Rise of Skywalker)" },
        { n: "81", name: "Cobb Vanth (The Book of Boba Fett)" },
        { n: "82", name: "Imperial Royal Guard (Star Wars: Return of the Jedi)" },
        { n: "83", name: "Xi'an (The Mandalorian)" },
        { n: "84", name: "Emperor Palpatine (Star Wars: Return of the Jedi)" },
        { n: "85", name: "Ponda Baba (Star Wars: A New Hope)" },
        { n: "86", name: "Count Dooku (Star Wars: Revenge of the Sith)" },
        { n: "87", name: "DJ (Star Wars: The Last Jedi)" },
        { n: "88", name: "Max Rebo (The Book of Boba Fett)" },
        { n: "89", name: "Yoda (Star Wars: Attack of the Clones)" },
        { n: "90", name: "Jek Porkins (Star Wars: A New Hope)" },
        { n: "91", name: "Poe Dameron (Star Wars: The Last Jedi)" },
        { n: "92", name: "Bail Organa (Star Wars: Attack of the Clones)" },
        { n: "93", name: "Nien Nunb (Star Wars: The Force Awakens)" },
        { n: "94", name: "Chewbacca (Star Wars: The Empire Strikes Back)" },
        { n: "95", name: "Ki-Adi-Mundi (Star Wars: The Phantom Menace)" },
        { n: "96", name: "Supreme Leader Snoke (Star Wars: The Force Awakens)" },
        { n: "97", name: "Plo Koon (Star Wars: The Phantom Menace)" },
        { n: "98", name: "General Hux (Star Wars: The Force Awakens)" },
        { n: "99", name: "Ahsoka Tano (The Book of Boba Fett)" },
        { n: "100", name: "Jyn Erso (Rogue One: A Star Wars Story)" },
    ],
  },
  {
    id: "animated-short-prints",
    type: "insert",
    title: "ANIMATED SHORT PRINTS",
    parallels: [
        { id: "red-refractors", name: "Red Refractors", print_run: 5, color: "#ff1744" },
        { id: "superfractors", name: "Superfractors", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "AS-1", name: "Obi-Wan Kenobi" },
        { n: "AS-2", name: "R2-D2" },
        { n: "AS-3", name: "Rey" },
        { n: "AS-4", name: "Mace Windu" },
        { n: "AS-5", name: "Han Solo" },
        { n: "AS-6", name: "Padmé Amidala" },
        { n: "AS-7", name: "Poe Dameron" },
        { n: "AS-8", name: "Ahsoka Tano" },
        { n: "AS-9", name: "Chewbacca" },
        { n: "AS-10", name: "Yoda" },
        { n: "AS-11", name: "Chancellor Palpatine" },
        { n: "AS-12", name: "C-3PO" },
        { n: "AS-13", name: "Boba Fett" },
        { n: "AS-14", name: "Lando Calrissian" },
        { n: "AS-15", name: "Darth Maul" },
        { n: "AS-16", name: "Luke Skywalker" },
        { n: "AS-17", name: "Jar Jar Binks" },
        { n: "AS-18", name: "Anakin Skywalker" },
        { n: "AS-19", name: "Jabba The Hutt" },
        { n: "AS-20", name: "Qui-Gon Jinn" },
        { n: "AS-21", name: "Kylo Ren" },
        { n: "AS-22", name: "Darth Vader" },
        { n: "AS-23", name: "BB-8" },
        { n: "AS-24", name: "The Grand Inquisitor" },
        { n: "AS-25", name: "Grand Admiral Thrawn" },
    ],
  },
  {
    id: "fantastic-fights",
    type: "insert",
    title: "FANTASTIC FIGHTS",
    parallels: [
        { id: "red-refractors", name: "Red Refractors", print_run: 5, color: "#ff1744" },
        { id: "superfractors", name: "Superfractors", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "FF-1", name: "Obi-Wan Kenobi vs. Darth Maul" },
        { n: "FF-2", name: "Qui-Gon Jinn vs. Darth Maul" },
        { n: "FF-3", name: "Mace Windu vs. Jango Fett" },
        { n: "FF-4", name: "Yoda vs. Count Dooku" },
        { n: "FF-5", name: "Anakin Skywalker vs. Count Dooku" },
        { n: "FF-6", name: "Obi-Wan Kenobi vs. Count Dooku" },
        { n: "FF-7", name: "Obi-Wan Kenobi vs. General Grievous" },
        { n: "FF-8", name: "Mace Windu vs. Palpatine" },
        { n: "FF-9", name: "Obi-Wan Kenobi vs. Anakin Skywalker" },
        { n: "FF-10", name: "Yoda vs. Darth Sidious" },
        { n: "FF-11", name: "Obi-Wan Kenobi vs. Anakin Skywalker" },
        { n: "FF-12", name: "Obi-Wan Kenobi vs. Darth Vader" },
        { n: "FF-13", name: "Luke Skywalker vs. Darth Vader" },
        { n: "FF-14", name: "Luke Skywalker vs. Darth Vader" },
        { n: "FF-15", name: "Ahsoka Tano vs. Magistrate Morgan Elsbeth" },
        { n: "FF-16", name: "The Mandalorian vs. Moff Gideon" },
        { n: "FF-17", name: "Rey vs. Kylo Ren" },
        { n: "FF-18", name: "Rey vs. The Praetorian Guards" },
        { n: "FF-19", name: "Kylo Ren vs. The Praetorian Guards" },
        { n: "FF-20", name: "Luke Skywalker vs. Kylo Ren" },
        { n: "FF-21", name: "Finn vs. Kylo Ren" },
        { n: "FF-22", name: "Rey vs. Palpatine" },
        { n: "FF-23", name: "Boba Fett vs. Cad Bane" },
        { n: "FF-24", name: "Darth Vader vs. Reva" },
        { n: "FF-25", name: "Din Djarin vs. Paz Viszla" },
    ],
  },
  {
    id: "autograph-cards",
    type: "auto",
    title: "AUTOGRAPH CARDS",
    parallels: [
        // TODO (rule 7): if this sub-set's BASE card is numbered, add a
        // blank-name serial slot at the base print run, e.g.
        //   { id: 'base', name: '', print_run: <N>, color: '#c8d8f0' },
        { id: "green-refractors", name: "Green Refractors", print_run: 99, color: "#00e676" },
        { id: "gold-refractors", name: "Gold Refractors", print_run: 50, color: "#f0c040" },
        { id: "orange-refractors", name: "Orange Refractors", print_run: 25, color: "#ff9100" },
        { id: "red-refractors", name: "Red Refractors", print_run: 5, color: "#ff1744" },
        { id: "superfractors", name: "Superfractors", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "A-AA", name: "Adria Arjona as Bix Caleen" },
        { n: "A-AB", name: "Ahmed Best as Jar Jar Binks" },
        { n: "A-AD", name: "Adam Driver as Kylo Ren" },
        { n: "A-AH", name: "Alfred Hsing as Pyke Traveler" },
        { n: "A-AP", name: "Alistair Petrie as General Draven" },
        { n: "A-AS", name: "Andy Serkis as Kino Loy" },
        { n: "A-BB", name: "Bernard Bullen as Father of the Mandalorian" },
        { n: "A-BE", name: "Crispian Belfrage as Devastator Captain" },
        { n: "A-BI", name: "Billie Lourd as Lieutenant Connix" },
        { n: "A-BM", name: "Ben Mendelsohn as Director Krennic" },
        { n: "A-BR", name: "Ralph Brown as Ric Olié" },
        { n: "A-BR2", name: "Zach Braff as Freck" },
        { n: "A-CA", name: "Mark Capri as Officer M'Kae" },
        { n: "A-CB", name: "Chris Bartlett as Zero" },
        { n: "A-CH", name: "Dave Chapman as BB-8" },
        { n: "A-CJ", name: "Carey Jones as Krrsantan" },
        { n: "A-CL", name: "Emilia Clarke as Qi'ra" },
        { n: "A-CO", name: "Hermione Corfield as Tallie Lintra" },
        { n: "A-CO2", name: "Dan Considine as Deck Officer Densin Chord" },
        { n: "A-CP", name: "Chad Parker as Padu Cherd" },
        { n: "A-CW", name: "Corey Dee Williams as Klaatu" },
        { n: "A-DA", name: "David Acord as FN-2199" },
        { n: "A-DC", name: "Dustin Ceithamer as Ned-B" },
        { n: "A-DE", name: "Indie Desroches as Corran" },
        { n: "A-DR", name: "Daisy Ridley as Rey" },
        { n: "A-ES", name: "Emily Swallow as The Armorer" },
        { n: "A-FJ", name: "Felicity Jones as Jyn Erso" },
        { n: "A-FM", name: "Faye Marsay as Vel Sartha" },
        { n: "A-FO", name: "Oliver Ford Davies as Sio Bibble" },
        { n: "A-FW", name: "Forest Whitaker as Saw Gerrera" },
        { n: "A-GE", name: "Giancarlo Esposito as Moff Gideon" },
        { n: "A-GF", name: "Gabe Fonseca as Duke Kayo Organa" },
        { n: "A-GH", name: "Guy Henry as Governor Tarkin" },
        { n: "A-GL", name: "Domhnall Gleeson as General Hux" },
        { n: "A-HA", name: "Harrison Davis as Pommet Warrick" },
        { n: "A-HE", name: "Werner Herzog as The Client" },
        { n: "A-HQ", name: "Hugh Quarshie as Captain Panaka" },
        { n: "A-IF", name: "Isla Farris as Winta" },
        { n: "A-II", name: "Ian Inigo as Cousin Niano Organa" },
        { n: "A-IM", name: "Ian McDiarmid as Emperor Palpatine" },
        { n: "A-IU", name: "Leilani Shiu as Jawa" },
        { n: "A-IV", name: "Indira Varma as Tala Durith" },
        { n: "A-IW", name: "Ian Whyte as Moroff" },
        { n: "A-JA", name: "Joseph Altin as Pilot Vanik" },
        { n: "A-JC", name: "Jake Cannavale as Toro Calican" },
        { n: "A-JG", name: "Julian Glover as General Veers" },
        { n: "A-JI", name: "Xavier Jimenez as Tusken Chief" },
        { n: "A-JL", name: "John Leguizamo as Gor Koresh" },
        { n: "A-KE", name: "Simone Kessell as Breha Organa" },
        { n: "A-KK", name: "Katy Kartwheel as Rio Durant" },
        { n: "A-KO", name: "Katy O'Brian as Elia Kane" },
        { n: "A-KR", name: "Nalini Krishan as Barriss Offee" },
        { n: "A-KT", name: "Kelly Marie Tran as Rose Tico" },
        { n: "A-LA", name: "Michaela Cottrell as Even Piell" },
        { n: "A-LNY", name: "Lupita Nyong'o as Maz Kanata" },
        { n: "A-MA", name: "Murphy Patrick Martin as Drummer" },
        { n: "A-MC", name: "Ryder McLaughlin as Wade Resselian" },
        { n: "A-MD", name: "Mark Dodson as Salacious B. Crumb" },
        { n: "A-MI", name: "Mike Edmonds as Logray" },
        { n: "A-MM", name: "Molly Miller as Handmaiden Agira" },
        { n: "A-MP", name: "Michael Pennington as Moff Jerjerrod" },
        { n: "A-MQ", name: "Mike Quinn as Nien Nunb" },
        { n: "A-MR", name: "Misty Rosas as Frog Lady" },
        { n: "A-MV", name: "Mercedes Varnado as Koska Reeves" },
        { n: "A-MW", name: "Ming-Na Wen as Fennec Shand" },
        { n: "A-NK", name: "Nick Kellington as Klaud" },
        { n: "A-NO", name: "Nick Nolte as Kuiil" },
        { n: "A-NP", name: "Natalie Portman as Padmé Amidala" },
        { n: "A-OA", name: "Omid Abtahi as Dr. Pershing" },
        { n: "A-OD", name: "Olivia d'Abo as Luminara Unduli" },
        { n: "A-PA", name: "Chris Parsons as 4-LOM" },
        { n: "A-PE", name: "Angelique Perrin as Adi Gallia" },
        { n: "A-PK", name: "Paul Kasey as C'ai Threnalli" },
        { n: "A-PL", name: "Paul Sun-Hyung Lee as Captain Carson Teva" },
        { n: "A-PW", name: "Paul Warren as Varmik" },
        { n: "A-QI", name: "Ming Qiu as Minas Velti" },
        { n: "A-RB", name: "Richard Brake as Valin Hess" },
        { n: "A-RD", name: "Rosario Dawson as Ahsoka Tano" },
        { n: "A-RG", name: "Richard E. Grant as General Pryde" },
        { n: "A-RK", name: "Rya Kihlstedt as Fourth Sister" },
        { n: "A-RO", name: "Rena Owen as Taun We" },
        { n: "A-SA", name: "Benny Safdie as Nari" },
        { n: "A-SB", name: "Skyler Bible as Fixer" },
        { n: "A-SH", name: "Kiran Shah as Neepers Panpick" },
        { n: "A-SK", name: "Stellan Skarsgard as Luthen Rael" },
        { n: "A-SKA", name: "Simon Kassianides as Axe Woves" },
        { n: "A-SP", name: "Roberta Sparta as Duchess Celly Organa" },
        { n: "A-SS", name: "Stephen Stanton as Admiral Raddus" },
        { n: "A-SW", name: "Jecobi Swain as Jayco" },
        { n: "A-TD", name: "Tim Dry as J'Quille" },
        { n: "A-TH", name: "Heath McGough as Groff Ditcher" },
        { n: "A-TM", name: "Temuera Morrison as Boba Fett" },
        { n: "A-TW", name: "Taika Waititi as IG-11" },
        { n: "A-VK", name: "Valene Kane as Lyra Erso" },
        { n: "A-VL", name: "Vivien Lyra Blair as Princess Leia Organa" },
        { n: "A-VS", name: "Varada Sethu as Cinta Kaz" },
        { n: "A-WD", name: "Warwick Davis as Wicket W. Warrick" },
        { n: "A-WI", name: "Sam Witwer as Maul" },
        { n: "A-YE", name: "Donnie Yen as Chirrut Îmwe" },
    ],
  },
  {
    id: "dark-side-all-red-autographs",
    type: "auto",
    title: "DARK SIDE ALL RED AUTOGRAPHS",
    parallels: [
        // TODO (rule 7): if this sub-set's BASE card is numbered, add a
        // blank-name serial slot at the base print run, e.g.
        //   { id: 'base', name: '', print_run: <N>, color: '#c8d8f0' },
        { id: "one-of-one", name: "", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "DS-AD", name: "Adam Driver as Kylo Ren" },
        { n: "DS-BM", name: "Ben Mendelsohn as Director Orson Krennic" },
        { n: "DS-GE", name: "Giancarlo Esposito as Moff Gideon" },
        { n: "DS-GL", name: "Domhnall Gleeson as General Hux" },
        { n: "DS-IM", name: "Ian McDiarmid as Supreme Chancellor Palpatine" },
        { n: "DS-JG", name: "Julian Glover as General Veers" },
        { n: "DS-MD", name: "Mark Dodson as Salacious B. Crumb" },
        { n: "DS-TM", name: "Temuera Morrison as Jango Fett" },
    ],
  },
  {
    id: "light-side-all-blue-autographs",
    type: "auto",
    title: "LIGHT SIDE ALL BLUE AUTOGRAPHS",
    parallels: [
        // TODO (rule 7): if this sub-set's BASE card is numbered, add a
        // blank-name serial slot at the base print run, e.g.
        //   { id: 'base', name: '', print_run: <N>, color: '#c8d8f0' },
        { id: "one-of-one", name: "", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "LS-AB", name: "Ahmed Best as Jar Jar Binks" },
        { n: "LS-BL", name: "Billie Lourd as Lieutenant Connix" },
        { n: "LS-BW", name: "Billy Dee Williams as Lando Calrissian" },
        { n: "LS-DY", name: "Donnie Yen as Chirrut Îmwe" },
        { n: "LS-FJ", name: "Felicity Jones as Jyn Erso" },
        { n: "LS-KT", name: "Kelly Marie Tran as Rose Tico" },
        { n: "LS-MQ", name: "Mike Quinn as Nien Nunb" },
        { n: "LS-RD", name: "Rosario Dawson as Ahsoka Tano" },
        { n: "LS-SR", name: "Daisy Ridley as Rey" },
        { n: "LS-TR", name: "Tim Rose as Admiral Ackbar" },
    ],
  },
];

export const ALL_CARD_KEYS = SETS.flatMap(set =>
  set.cards.map(card => `${set.id}__${card.n}`)
);

// Fallback exports used by Checklist.js for any sub-set with no inline `parallels`.
// Every sub-set above has its own inline array, so these stay empty.
export const PARALLELS = [];
export const AUTO_PARALLELS = [];
export const INSERT_PARALLELS = [];
